module.exports = __webpack_public_path__ + "img/opciones-inversion-portada.708a13d8.webp";